import {
    CrudMode,
    DataDisplay,
    Grid,
    pn,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { ScholarshipStatus, ScholarshipStatusEditResource, ScholarshipStatusViewResource } from "generated/openApi";
import produce from "immer";

export const ScholarshipStatusPageBody = (props: {
    scholarshipStatus: ScholarshipStatus;
    setScholarshipStatus(arg0: any): void;
    crudMode: CrudMode;
    viewResource: ScholarshipStatusViewResource;
    editResource: ScholarshipStatusEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<ScholarshipStatus>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.scholarshipStatus.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.scholarshipStatus.name}
                onChange={(e) =>
                    props.setScholarshipStatus(
                        produce(props.scholarshipStatus, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};
